import PropTypes from 'prop-types';
import './ScanCardFields.scss';

/**
 * ScanCardFields component - displays the scan fields/settings
 * @param {Array} fields - Array of field objects with id and values
 * @returns React component that renders the fields section
 */
const ScanCardFields = ({ fields }) => {
  /**
   * Generate scan settings text from fields.
   */
  const mapFields = () => {
    if (!fields || fields.length === 0) {
      return '';
    }

    return fields.flatMap((field) => field.values || []).join(', ');
  };

  const fieldsText = mapFields();

  return (
    <div className="scan-card-fields">
      <span className="scan-card-fields-text">{fieldsText}</span>
    </div>
  );
};

ScanCardFields.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      values: PropTypes.arrayOf(PropTypes.string)
    })
  )
};

export default ScanCardFields;
